import { render } from "./B2bNewUserPermissions.vue?vue&type=template&id=1bd404f5&scoped=true&lang=pug"
import script from "./B2bNewUserPermissions.vue?vue&type=script&lang=js"
export * from "./B2bNewUserPermissions.vue?vue&type=script&lang=js"

import "./B2bNewUserPermissions.vue?vue&type=style&index=0&id=1bd404f5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd404f5"]])

export default __exports__